var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import PurBackService from "../../../api/PurBackService";
import ShopAfterSalesService from "../../../api/ShopAfterSalesService";
var PurBackDio = (function (_super) {
    __extends(PurBackDio, _super);
    function PurBackDio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.msg = '';
        _this.type = '';
        _this.tableData = [];
        _this.tableHeight = 125;
        _this.templateRadio = [];
        _this.selectRows = [];
        return _this;
    }
    PurBackDio.prototype.mounted = function () {
        this.tableData = this.data;
    };
    PurBackDio.prototype.created = function () {
        this.service = PurBackService.getInstance();
        this.shopService = ShopAfterSalesService.getInstance();
    };
    PurBackDio.prototype.changeSelection = function (Rowindex, row, index) {
        console.log(Rowindex, row, index);
        this.selectRows[index] = row;
        this.selectRows[index].order_id = this.tableData[index].order_id;
    };
    PurBackDio.prototype.save = function () {
        var _this = this;
        if (this.selectRows.length !== this.tableData.length) {
            this.$message.error("请选择单据替换货商品后再提交");
            return;
        }
        var func = this.service.audit;
        var params = {
            order_ids: this.tableData.map(function (item) { return item.order_id; }).join(','),
            order_goods_replace_map: JSON.stringify(this.selectRows)
        };
        if (this.type === 'saleAfter') {
            func = this.shopService.handle;
            params = Object.assign(params, this.saleAfterParams);
        }
        console.log(22, params);
        func(params).then(function (res) {
            _this.selectRows = [];
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg || "操作成功");
            }
            _this.$closeDialog();
            _this.$emit('save:ok');
        });
    };
    PurBackDio.prototype.close = function () {
        this.$closeDialog();
    };
    PurBackDio.prototype.inputChange = function () {
    };
    PurBackDio = __decorate([
        Component({})
    ], PurBackDio);
    return PurBackDio;
}(VueDialog));
export default PurBackDio;
